import React, { HTMLAttributes } from 'react';
import Button from '@atlaskit/button';
import HelpIcon from '@atlaskit/icon/glyph/question-circle';
import InlineDialog, { Placement } from '@atlaskit/inline-dialog';
import { css } from '@emotion/core';

import { useOpenableController } from '@/controllers';
import { flex, helpDialogWithInterest } from '@/styles';
import { FCC } from '@/utils/types';

const copyLayoutStyles = css`
  display: grid;
  gap: 1em;
`;

type HelpDialogProps = {
  // eslint-disable-next-line react/no-unused-prop-types
  title?: string;
  placement?: Placement;
  withInterest?: boolean;
} & Pick<HTMLAttributes<HTMLDivElement>, 'className'>;

const HelpDialog: FCC<HelpDialogProps> = ({
  withInterest = false,
  className,
  children,
  placement,
}) => {
  const modal = useOpenableController();

  return (
    <div className={className} css={[flex, withInterest ? helpDialogWithInterest : '']}>
      <InlineDialog
        placement={placement}
        onClose={modal.onClose}
        content={<span css={copyLayoutStyles}>{children}</span>}
        isOpen={modal.isOpen}
      >
        <Button
          appearance="subtle"
          onClick={modal.onToggle}
          isSelected={modal.isOpen}
          iconBefore={<HelpIcon size="medium" label="Help" />}
        />
      </InlineDialog>
    </div>
  );
};

export default HelpDialog;
